module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[44]287.50f0783.woff2";